import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = 'manualEntry/Type/Select';

export function CasRHFManualEntryTypeSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasManualEntryTypeSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
